/** @module csi/skintheme/Luxe */
define([], function() {
	return {
		Blue1: "Blue30",
		Blue2: "Blue50",
		Blue3: "Black600",

		PrimaryBlue: "Black100",
		PrimaryDisabledColor: "Grey700",
		PrimaryColor2: "Black300",
		PrimaryColor3: "Blue600",

		SiteHeaderBackground: "Black100",

		CompanyHeaderBlue1: "Black100",
		CompanyHeaderBlue2: "Black300",

		/* LINK */
		LinkNormal: "Blue600",
		LinkHover: "Blue800",
		LinkActive: "Blue600",

		/* Comment */
		CommentActiveColor: "Blue600",

		/** custom view */
		CustomViewOptionActiveColor: "Blue500",

		/* FULL SCREEN HEADER */
		FullScreenHeaderBackgroundColor: "Black100",
		FullScreenLogoBackgroundColor: "Black100",

		/* TEXT */
		TabsTextActive: "PrimaryText",

		/* Button */
		BtnPrimaryFocusedBorderColor: "Blue600",
		ButtonSwitchNormalIconStateOnBackgroundColor: "Black100",

		/* BreadCrumb */
		BreadcrumbNormalLinkColor: "Blue600",

		/* CheckBox */
		CheckBoxFocusColor: "Blue300",

		/* Text Border */
		TextfieldActiveBorderColor: "PrimaryColor",
		BtnToolbarFocusedBorderColor: "PrimaryColor",

		/* DropDown */
		DropdownSelectActiveBorderColor: "PrimaryColor",

		/* Header */
		LastVisitedBackgroundColor: "PrimaryWhite",
		LastVisitedIconColor: "SiteHeaderBackground",
		PageHeaderButtonTextColor: "PrimaryWhite",
		PageHeaderToolbarIconColor: "PrimaryWhite",
		PageHeaderToolbarHoverColor: "PrimaryWhite",
		PageHeaderSearchInButtonHoverColor: "BtnSecondaryHoverBackgroundColor",
		PageHeaderToolbarSeparatorColor: "WhiteOpacity20",
		PageHeaderSearchScopeBackgroundColor: "BtnSecondaryNormalBackgroundColor",
		PageHeaderSearchBlockBackgroundColor: "TextfieldNormalBackgroundColor",
		CompanyLogoTextColor: "WhiteTextColor",
		CompanyLogoImageURL: "DarkCompanyLogoIconURL",
		ExitFullScreenIconURL: "DarkExitFullScreenIconURL",

		/* Table */
		TableCopyBorderColor: "Blue600",
		TablePasteBorderColor: "Blue600",
		TableNewRowBackgroundColor: "Blue100",

		/* Slicer */
		SlicerMetricsBackgroundColor: "Blue100",

		/* Chart */
		ChartAreaURL: "ChartAreaBlueURL",
		ChartBarURL: "ChartBarBlueURL",
		ChartColumnURL: "ChartColumnBlueURL",
		ChartDoughnutURL: "ChartDoughnutBlueURL",
		ChartLineURL: "ChartLineBlueURL",
		ChartMsAreaURL: "ChartMsAreaBlueURL",
		ChartMsBarURL: "ChartMsBarBlueURL",
		ChartMsColumnURL: "ChartMsColumnBlueURL",
		ChartMsLineURL: "ChartMsLineBlueURL",
		ChartParetoURL: "ChartParetoBlueURL",
		ChartPieURL: "ChartPieBlueURL",
		ChartStackedAreaURL: "ChartStackedAreaBlueURL",
		ChartStackedBarURL: "ChartStackedBarBlueURL",
		ChartStackedColumnURL: "ChartStackedColumnBlueURL",

		/* Progress bar */
		ProgressBarDeterminateProgressColor: "Blue600",

		HighlightSelected: "Grey200"
	};
});